var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "compaire-movie-box" },
    [
      _c("div", { staticClass: "title as-flex main-between cross-center" }, [
        _c("div", { staticClass: "left-title f-3" }, [_vm._v("对比影片")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right-add-btn f-2",
            on: { click: _vm.addCompaireMovies },
          },
          [_vm._v("添加")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main as-flex main-start cross-center" },
        [
          _c("moviesSoftScroll", {
            attrs: { movieListBriefInfo: _vm.movieListBriefInfo },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "addmovie-customize-dialog",
            visible: _vm.showAddCompaireMoviesModal,
            width: "70%",
            top: "0px",
            "modal-append-to-body": true,
            "append-to-body": true,
            "lock-scroll": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddCompaireMoviesModal = $event
            },
          },
        },
        [
          _vm.showAddCompaireMoviesModal
            ? [_c("addMovieModal", { on: { close: _vm.closeModal } })]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }